<template>
    <form id="form-regulatory-affairs" v-on:submit.prevent="validateBeforeSubmit">
        <div class="form-group">
            <ejs-dropdownlist v-model="dataForm.tenants" :dataSource='dataSourceTenants' :fields='fieldsSourceTenants' placeholder='Tenans' autocomplete="off"></ejs-dropdownlist>
        </div>
        <div class="form-group">
            <ejs-textbox v-model="dataForm.affair" :placeholder="$t('textRegulatoryAffairs.textFormAffair')" data-msg-containerid="affairError" :data-required-message="$t('textRegulatoryAffairs.textErrorAffair')" autocomplete="off" required></ejs-textbox>
            <div id="affairError"></div>
        </div>
        <div class="form-group">
            <ejs-dropdownlist v-model="dataForm.topic" :dataSource='dataSourceTopic' :fields='fieldsSourceTopic' :select="onChangeTopic" :placeholder="$t('textRegulatoryAffairs.textFormTopic')" autocomplete="off"></ejs-dropdownlist>
        </div>
        <div class="form-group">
            <ejs-dropdownlist v-model="dataForm.subtopic" :readonly="dataForm.topic == ''" :dataSource='dataSourceSubtopic' :fields='fieldsSourceSubtopic' :query='querySubtopic' :placeholder="$t('textRegulatoryAffairs.textFormSubTopic')" autocomplete="off"></ejs-dropdownlist>
        </div>
        <div class="form-group">
            <ejs-multiselect v-model="dataForm.keywords" :allowCustomValue='true' :placeholder="$t('textRegulatoryAffairs.textFormKeywords')"></ejs-multiselect>
        </div>
        <ejs-button type='submit' cssClass="e-primary mt-3">Guardar</ejs-button>
    </form>
</template>
<script>
import axios from 'axios';
import { Query } from '@syncfusion/ej2-data';
export default {
    name: "regulatory-affairs-form",
    props: ["data"],
    data() {
        return {
            formObj: '',
            dataForm: {
                id: '',
                tenants: '',
                affair: '',
                topic: '',
                subtopic: '',
                keywords: '',
            },
            dataSourceTenants: [],
            fieldsSourceTenants: {text: 'razonSocial', value: 'TID'},
            dataSourceTopic: [],
            fieldsSourceTopic: {text: 'tema', value: 'id'},
            dataSourceSubtopic: [],
            fieldsSourceSubtopic: {text: 'subtema', value: 'id'},
            querySubtopic:  null
        }
    },
    mounted: function () {
        this.formObj = new FormValidator('#form-regulatory-affairs');
    },
    methods: {
        initRegulatoryAffairsForm: function() {
            Vue.prototype.$eventHub.$emit('onShowSpinner');
            axios.post('/auth/regulatoryAffairs/getRegulatoryAffairsForms').then(response => {
                this.dataSourceTenants.push({razonSocial: 'PÚBLICO', TID: ''});
                response.data.tenants.forEach(element => {
                    this.dataSourceTenants.push({razonSocial: element.razonSocial.toUpperCase(), TID: element.TID});
                });
                this.dataSourceTopic = response.data.topic;
                this.dataSourceSubtopic = response.data.subtopic;
            });
            Vue.prototype.$eventHub.$emit('onHideSpinner');
            if(this.data) {
                this.dataForm.id = this.data.id;
                this.dataForm.tenants = this.data.TID ? this.data.TID : '';
                this.dataForm.affair = this.data.asunto;
                this.dataForm.topic = this.data.tema_id;
                this.dataForm.subtopic = this.data.subtema_id;
                this.dataForm.keywords = this.data.keywords.split(',');
            }
        },
        onChangeTopic: function(args) {
            this.querySubtopic = new Query().where('tema_id', 'equal', args.itemData.id);
        },
        validateBeforeSubmit: function() {
            let formStatus = this.formObj.validate();
            if(formStatus) {
                this.formObj.refresh();
                axios.post('/auth/regulatoryAffairs/setRegulatoryAffairsAdd', this.dataForm).then(response => {
                    Vue.prototype.$eventHub.$emit('onInitManageRegulatoryAffairs');
                    Vue.prototype.$eventHub.$emit('closeSidebarClick');
                    Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                });
            }
        },
    },
    created() {
        this.initRegulatoryAffairsForm();
    }
}
</script>